import React, { Component } from "react";
import Button from "@atlaskit/button";

import "./photosBtn.css";
export default class PhotosBtn extends Component {
  render() {
    return (
      <Button
        onClick={this.props.btnClick}
        appearance="default"
        className="banner__photos-btn"
      >
        View Photos
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/photosBtn/PhotosBtn.js